import { j as s } from "../../../../node_modules/react/jsx-runtime.js";
import n from "../../Button/Button.js";
import { memo as a } from "react";
const m = ({ footer: i }) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center pt-100 pb-075 gap-100", children: [
  (i == null ? void 0 : i.secondaryAction) && /* @__PURE__ */ s.jsx(
    n,
    {
      variant: "outlined",
      ...i.secondaryAction,
      color: "neutral",
      size: "small"
    }
  ),
  (i == null ? void 0 : i.primaryAction) && /* @__PURE__ */ s.jsx(
    n,
    {
      variant: "outlined",
      ...i.primaryAction,
      color: "primary",
      size: "small"
    }
  )
] }), l = a(m);
export {
  l as default
};
//# sourceMappingURL=Actions.js.map
